// import package
import io from 'socket.io-client';

// import lib
import config from './config';

const socket = io(config.SOCKET_URL);
socket.on('connect', function () {
    console.log('Client connected');
});

const createSocketUser = (userId) => {
    socket.emit('CREATEROOM', userId)
}

socket.on('userAsset', function (data) {
})

export {
    socket,
    createSocketUser
}